// src/App.jsx
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Components
import Header from './components/Header/Header';
import HeroSection from './components/Hero/HeroSection';
import FloatingActions from './components/FloatingActions/FloatingActions';
import WhyChooseSection from './components/WhyChoose/WhyChooseSection';
import ProductsSection from './components/Products/ProductsSection';
import EMICalculatorSection from './components/EMICalculator/EMICalculatorSection';
import EligibilityScorecardSection from './components/EligibilityScorecard/EligibilityScorecardSection';
import TestimonialsSection from './components/Testimonials/TestimonialsSection';
import BlogSection from './components/Blog/BlogSection';
import ImportantNewsSection from './components/Annonuncement/ImportantNewsSection';  //new scrolling section
import Footer from './components/Footer/Footer';
import PMAY2Page from './components/PMAY/PMAY2Page';
import PartnerWithUs from './components/Partner/PartnerWithUs';
import Governance from './components/Goverence/goverence';
import Career from './components/Career/Career';
import AboutUs from './components/About/AboutUs';
import HomeConstructionLoanPage from './components/Loans/HomeConstructionLoanPage.jsx';
import JobDetails from './components/Career/JobDetails';
import ContactUs from "./components/Contact/ContactUs";
import FestivalCampaign from "./components/FestivalCampaign/FestivalCampaign";

import Customer360EligibilityCalculator from "./components/Customer360EligibilityCalculator/Customer360EligibilityCalculator";
import ManagementTeamSection from './components/ManagementTeam/ManagementTeamSection';
import Directors from "./components/Directors/Directors";
import Blog from './components/Blog/Blog';
import RiskClassification from "./components/RiskClassification/RiskClassification";
import Faq from "./components/Faq/faq";
import LifeAham from "./components/Life@Aham/LifeAtAham.js";
import AhamMoments from "./components/Gallery/AhamMoments";
import InvestorInfo from "./components/InvestorInfo/InvestorInfo";
import Grievances from "./components/Grievances/GrievancesRedressal";
import DSAOnboarding from "./components/DSA/DSAOnboarding";
import ThankYou from "./components/ThankYou/ThankYou";
import ScorecardFrontendPage from './components/Scorecard/ScorecardPage';
import EMICalculatorFrontendPage from './components/EMICalculator/EMICalculatorFrontendPage';

import EAuction from "./components/EAuction/EAuction";
import RatingCertificate from "./components/Rating/RatingCertificate";
import SecuredAssets from "./components/SecuredAssets/SecuredAssets";
import CorporateGovernance from "./components/Corporate/CorporateGovernance";
import Leadership from "./components/Partnership/LeadershipPage.jsx";


import HomeCompositeLoanPage from './components/Loans/CompositeLoanPage.jsx';
import NRILoanPage from './components/Loans/NRILoanPage.jsx';
import HomePurchaseLoanPage from './components/Loans/HomePurchaseLoanPage.jsx';
import HomeRenovationLoanPage from './components/Loans/HomeRenovationLoanpage.jsx';
import HomeRenovationLoanOverviewPage from './admin/pages/HomeRenovationLoanOverviewPage.js';
import HomeRenovationLoanKeyBenefitsPage from './admin/pages/HomeRenovationLoanKeyBenefitsPage.js';
import HomeExtensionLoanOverviewPage from './admin/pages/HomeExtensionLoanOverviewPage.js';
import HomeExtensionLoanKeyBenefitsPage from './admin/pages/HomeExtensionLoanKeyBenefitsPage.js';
import HomeExtensionLoanEligibilityPage from './admin/pages/HomeExtensionLoanEligibilityPage';
import HomeExtensionLoanDocumentsPage from './admin/pages/HomeExtensionLoanDocumentsPage';
import HomeExtensionLoanPage from './components/Loans/HomeExtensionLoanPage.jsx';
import BalanceTransferLoan from './components/Loans/BalanceTransferLoan.jsx';
import TopUpLoan from './components/Loans/TopUpLoan.jsx';
import MortgageLoan from './components/Loans/MortgageLoan.jsx';

import DSAPartnerProgram from "./components/DSA/DSAPartnerProgram";
import BlogInner from './components/Blog/BlogInner';
import BranchLocator from "./components/BranchLocator/BranchLocator";
import MaduraiBranch from "./components/BranchLocator/MaduraiBranch";
import BranchPageTemplate from "./components/BranchLocator/BranchPageTemplate";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import CookiePolicy from "./components/CookiePolicy/CookiePolicy";
import Preloader from "./components/ui/Preloader";

// Admin Context & Components
import { AuthProvider } from './admin/context/AuthContext';
import ProtectedRoute from './admin/components/ProtectedRoute';
import AdminLayout from './admin/layouts/AdminLayout';
import LoginPage from './admin/pages/LoginPage';
import Dashboard from './admin/pages/Dashboard';
import BannersPage from './admin/pages/BannersPage';
import WhyChoosePage from './admin/pages/WhyChoosePage';
import ProductsPage from './admin/pages/ProductsPage';
import EMICalculatorPage from './admin/pages/EMICalculatorPage';
import TestimonialsPage from './admin/pages/TestimonialsPage';
import ScorecardPage from './admin/pages/ScorecardPage';
import AdminScorecardEligibilityCardsPage from './admin/pages/AdminScorecardEligibilityCardsPage.jsx';
import AdminScorecardMaxLoanPage from './admin/pages/AdminScorecardMaxLoanPage.jsx';
import AdminScorecardEligibilityFactorsPage from './admin/pages/AdminScorecardEligibilityFactorsPage.jsx';
import AdminScorecardEligibilityTipsPage from './admin/pages/AdminScorecardEligibilityTipsPage.jsx';
import AdminScorecardBeyondNumbersPage from './admin/pages/AdminScorecardBeyondNumbersPage.jsx';
import AdminScorecardWhyChoosePage from './admin/pages/AdminScorecardWhyChoosePage.jsx';
import AdminScorecardFaqsPage from './admin/pages/AdminScorecardFaqsPage.jsx';
import AdminScorecardProductsPage from './admin/pages/AdminScorecardProductsPage.jsx';
import ImportantNewsPage from './admin/pages/ImportantNewsPage';
import HomeConstructionLoanBannersPage from './admin/pages/HomeConstructionLoanBannersPage';
import HomeConstructionLoanOverviewPage from './admin/pages/HomeConstructionLoanOverviewPage';
import HomeConstructionLoanKeyBenefitsPage from './admin/pages/HomeConstructionLoanKeyBenefitsPage';
import HomeConstructionLoanEligibilityPage from './admin/pages/HomeConstructionLoanEligibilityPage';
import HomeConstructionLoanDocumentsPage from './admin/pages/HomeConstructionLoanDocumentsPage';
import HomeConstructionLoanInterestRatesPage from './admin/pages/HomeConstructionLoanInterestRatesPage';
import HomeConstructionLoanFAQPage from './admin/pages/HomeConstructionLoanFAQPage';
import HomeConstructionLoanCTABannerPage from './admin/pages/HomeConstructionLoanCTABannerPage';
import HomePurchaseLoanBannersPage from './admin/pages/HomePurchaseLoanBannersPage';
import HomePurchaseLoanOverviewPage from './admin/pages/HomePurchaseLoanOverviewPage';
import HomePurchaseLoanKeyBenefitsPage from './admin/pages/HomePurchaseLoanKeyBenefitsPage';
import HomePurchaseLoanEligibilityPage from './admin/pages/HomePurchaseLoanEligibilityPage';
import HomePurchaseLoanDocumentsPage from './admin/pages/HomePurchaseLoanDocumentsPage';
import HomePurchaseLoanInterestRatesPage from './admin/pages/HomePurchaseLoanInterestRatesPage';
import HomePurchaseLoanFAQPage from './admin/pages/HomePurchaseLoanFAQPage';
import HomePurchaseLoanCTABannerPage from './admin/pages/HomePurchaseLoanCTABannerPage';
import HomeCompositeLoanBannersPage from './admin/pages/HomeCompositeLoanBannersPage';
import HomeCompositeLoanOverviewPage from './admin/pages/HomeCompositeLoanOverviewPage';
import HomeCompositeLoanKeyBenefitsPage from './admin/pages/HomeCompositeLoanKeyBenefitsPage';
import HomeCompositeLoanEligibilityPage from './admin/pages/HomeCompositeLoanEligibilityPage';
import HomeCompositeLoanDocumentsPage from './admin/pages/HomeCompositeLoanDocumentsPage';
import HomeCompositeLoanInterestRatesPage from './admin/pages/HomeCompositeLoanInterestRatesPage';
import HomeCompositeLoanFAQPage from './admin/pages/HomeCompositeLoanFAQPage';
import HomeCompositeLoanCTABannerPage from './admin/pages/HomeCompositeLoanCTABannerPage';
import HomeRenovationLoanBannersPage from './admin/pages/HomeRenovationLoanBannersPage';
import HomeRenovationLoanEligibilityPage from './admin/pages/HomeRenovationLoanEligibilityPage';
import HomeRenovationLoanDocumentsPage from './admin/pages/HomeRenovationLoanDocumentsPage';
import HomeRenovationLoanInterestRatesPage from './admin/pages/HomeRenovationLoanInterestRatesPage';
import HomeExtensionLoanBannersPage from './admin/pages/HomeExtensionLoanBannersPage';
import HomeRenovationLoanFAQPage from './admin/pages/HomeRenovationLoanFAQPage';
import HomeRenovationLoanCTABannerPage from './admin/pages/HomeRenovationLoanCTABannerPage';
import HomeExtensionLoanInterestRatesPage from './admin/pages/HomeExtensionLoanInterestRatesPage';
import HomeExtensionLoanFAQPage from './admin/pages/HomeExtensionLoanFAQPage';
import HomeExtensionLoanCTABannerPage from './admin/pages/HomeExtensionLoanCTABannerPage';
import BalanceTransferLoanBannersPage from './admin/pages/BalanceTransferLoanBannersPage';
import BalanceTransferLoanOverviewPage from './admin/pages/BalanceTransferLoanOverviewPage';
import BalanceTransferLoanKeyBenefitsPage from './admin/pages/BalanceTransferLoanKeyBenefitsPage';
import BalanceTransferLoanEligibilityPage from './admin/pages/BalanceTransferLoanEligibilityPage';
import BalanceTransferLoanDocumentsPage from './admin/pages/BalanceTransferLoanDocumentsPage';
import BalanceTransferLoanInterestRatesPage from './admin/pages/BalanceTransferLoanInterestRatesPage';
import BalanceTransferLoanFAQPage from './admin/pages/BalanceTransferLoanFAQPage';
import BalanceTransferLoanCTABannerPage from './admin/pages/BalanceTransferLoanCTABannerPage';
import NRILoanBannersPage from './admin/pages/NRILoanBannersPage';
import NRILoanOverviewPage from './admin/pages/NRILoanOverviewPage';
import NRILoanKeyBenefitsPage from './admin/pages/NRILoanKeyBenefitsPage';
import NRILoanEligibilityPage from './admin/pages/NRILoanEligibilityPage';
import NRILoanDocumentsPage from './admin/pages/NRILoanDocumentsPage';
import NRILoanInterestRatesPage from './admin/pages/NRILoanInterestRatesPage';
import NRILoanFAQPage from './admin/pages/NRILoanFAQPage';
import NRILoanCTABannerPage from './admin/pages/NRILoanCTABannerPage';
import TopUpLoanBannersPage from './admin/pages/TopUpLoanBannersPage';
import TopUpLoanOverviewPage from './admin/pages/TopUpLoanOverviewPage';
import TopUpLoanKeyBenefitsPage from './admin/pages/TopUpLoanKeyBenefitsPage';
import TopUpLoanEligibilityPage from './admin/pages/TopUpLoanEligibilityPage';
import TopUpLoanDocumentsPage from './admin/pages/TopUpLoanDocumentsPage';
import TopUpLoanInterestRatesPage from './admin/pages/TopUpLoanInterestRatesPage';
import TopUpLoanFAQPage from './admin/pages/TopUpLoanFAQPage';
import TopUpLoanCTABannerPage from './admin/pages/TopUpLoanCTABannerPage';
import MortgageLoanBannersPage from './admin/pages/MortgageLoanBannersPage';
import MortgageLoanOverviewPage from './admin/pages/MortgageLoanOverviewPage';
import MortgageLoanKeyBenefitsPage from './admin/pages/MortgageLoanKeyBenefitsPage';
import MortgageLoanEligibilityPage from './admin/pages/MortgageLoanEligibilityPage';
import MortgageLoanDocumentsPage from './admin/pages/MortgageLoanDocumentsPage';
import MortgageLoanInterestRatesPage from './admin/pages/MortgageLoanInterestRatesPage';
import MortgageLoanFAQPage from './admin/pages/MortgageLoanFAQPage';
import MortgageLoanCTABannerPage from './admin/pages/MortgageLoanCTABannerPage';
import DSAPartnerProgramBannersPage from './admin/pages/DSAPartnerProgramBannersPage';
import DSAPartnerProgramOverviewPage from './admin/pages/DSAPartnerProgramOverviewPage';
import DSAPartnerProgramBenefitsPage from './admin/pages/DSAPartnerProgramBenefitsPage';
import DSAPartnerProgramWhoCanJoinPage from './admin/pages/DSAPartnerProgramWhoCanJoinPage';
import DSAPartnerProgramHowItWorksPage from './admin/pages/DSAPartnerProgramHowItWorksPage';
import DSAPartnerProgramSupportTrainingPage from './admin/pages/DSAPartnerProgramSupportTrainingPage';
import DSAPartnerProgramSuccessStoriesPage from './admin/pages/DSAPartnerProgramSuccessStoriesPage';
import DSAPartnerProgramRegistrationRequirementsPage from './admin/pages/DSAPartnerProgramRegistrationRequirementsPage';
import DSAPartnerProgramFAQPage from './admin/pages/DSAPartnerProgramFAQPage';
import AdminGMBBranchManagement from './admin/pages/AdminGMBBranchManagement';
import AdminGMBSectionEditor from './admin/pages/AdminGMBSectionEditor';
import HighDemandProductsPage from './admin/pages/HighDemandProductsPage';
import DSAPartnerProgramCTABannerPage from './admin/pages/DSAPartnerProgramCTABannerPage';
import InvestorInfoBannersPage from './admin/pages/InvestorInfoBannersPage';
import InvestorFoundationSettingsPage from './admin/pages/InvestorFoundationSettingsPage';
import InvestorFoundationPointsPage from './admin/pages/InvestorFoundationPointsPage';
import InvestorProgressSettingsPage from './admin/pages/InvestorProgressSettingsPage';
import InvestorProgressHighlightsPage from './admin/pages/InvestorProgressHighlightsPage';
import InvestorTrustSettingsPage from './admin/pages/InvestorTrustSettingsPage';
import InvestorGovernanceHighlightsPage from './admin/pages/InvestorGovernanceHighlightsPage';
import InvestorInfoCTABannerPage from './admin/pages/InvestorInfoCTABannerPage';
import PMAYBannersPage from './admin/pages/PMAYBannersPage';
import PMAYOverviewPage from './admin/pages/PMAYOverviewPage';
import PMAYEligibilityPage from './admin/pages/PMAYEligibilityPage';
import GovernanceBannersPage from './admin/pages/GovernanceBannersPage';
import GovernanceFoundationPage from './admin/pages/GovernanceFoundationPage';
import GovernanceTransparencyPage from './admin/pages/GovernanceTransparencyPage';
import GovernanceOversightPage from './admin/pages/GovernanceOversightPage';
import GovernanceEthicsPage from './admin/pages/GovernanceEthicsPage';
import GovernanceCTABannerPage from './admin/pages/GovernanceCTABannerPage';
import DSAOnboardingBannersPage from './admin/pages/DSAOnboardingBannersPage';
import DSAOnboardingBenefitsPage from './admin/pages/DSAOnboardingBenefitsPage';
import DSAOnboardingStepsPage from './admin/pages/DSAOnboardingStepsPage';
import DSAOnboardingRequirementsPage from './admin/pages/DSAOnboardingRequirementsPage';
import DSAOnboardingCTABannerPage from './admin/pages/DSAOnboardingCTABannerPage';
import RiskClassificationBannersPage from './admin/pages/RiskClassificationBannersPage';
import RiskClassificationCardsPage from './admin/pages/RiskClassificationCardsPage';
import RiskClassificationTablePage from './admin/pages/RiskClassificationTablePage';
import EAuctionBannersPage from './admin/pages/EAuctionBannersPage';
import EAuctionProcessPage from './admin/pages/EAuctionProcessPage';
import EAuctionPropertiesPage from './admin/pages/EAuctionPropertiesPage';
import EAuctionGettingStartedPage from './admin/pages/EAuctionGettingStartedPage';
import EAuctionLegalInformationPage from './admin/pages/EAuctionLegalInformationPage';
import RatingCertificateBannersPage from './admin/pages/RatingCertificateBannersPage';
import RatingCertificateValuePage from './admin/pages/RatingCertificateValuePage';
import RatingCertificateCredentialsPage from './admin/pages/RatingCertificateCredentialsPage';
import RatingBehindScenesPage from './admin/pages/RatingBehindScenesPage';
import RatingCertificateAdvantagePage from './admin/pages/RatingCertificateAdvantagePage';
import RatingCertificatePledgePage from './admin/pages/RatingCertificatePledgePage';
import RatingCertificateAssessmentsPage from './admin/pages/RatingCertificateAssessmentsPage';
import RatingCertificateCTAPage from './admin/pages/RatingCertificateCTAPage';

import GrievancesRedressalBannersPage from './admin/pages/GrievancesRedressalBannersPage';
import GrievancesRedressalStepsPage from './admin/pages/GrievancesRedressalStepsPage';
import GrievanceComplaintMethodsPage from './admin/pages/GrievanceComplaintMethodsPage';
import GrievanceLevel2Page from './admin/pages/GrievanceLevel2Page';
import GrievanceLevel3Page from './admin/pages/GrievanceLevel3Page';
import GrievanceCommitmentPage from './admin/pages/GrievanceCommitmentPage';

import SecuredAssetsBannersPage from './admin/pages/SecuredAssetsBannersPage';
import SecuredAssetsCoreConceptPage from './admin/pages/SecuredAssetsCoreConceptPage';
import SecuredAssetsFinancePage from './admin/pages/SecuredAssetsFinancePage';
import SecuredAssetsTermsPage from './admin/pages/SecuredAssetsTermsPage';
import SecuredAssetsDefaultPage from './admin/pages/SecuredAssetsDefaultPage';
import SecuredAssetsReleasePage from './admin/pages/SecuredAssetsReleasePage';
import SecuredAssetsCTABannerPage from './admin/pages/SecuredAssetsCTABannerPage';
import SecuredAssetsTablePage from './admin/pages/SecuredAssetsTablePage';
import LifeAtAhamBannersPage from './admin/pages/LifeAtAhamBannersPage';
import LifeAtAhamCulturePage from './admin/pages/LifeAtAhamCulturePage';
import LifeAtAhamThrivePage from './admin/pages/LifeAtAhamThrivePage';
import LifeAtAhamJourneyPage from './admin/pages/LifeAtAhamJourneyPage';
import LifeAtAhamBeyondPage from './admin/pages/LifeAtAhamBeyondPage';
import LifeAtAhamRecognitionPage from './admin/pages/LifeAtAhamRecognitionPage';
import LifeAtAhamCTABannerPage from './admin/pages/LifeAtAhamCTABannerPage';
import GalleryBannersPage from './admin/pages/GalleryBannersPage';
import GalleryWorkImagesPage from './admin/pages/GalleryWorkImagesPage';
import GalleryCelebrationImagesPage from './admin/pages/GalleryCelebrationImagesPage';
import GalleryGrowthImagesPage from './admin/pages/GalleryGrowthImagesPage';
import GalleryCTAManagementPage from './admin/pages/GalleryCTAManagementPage';
import AboutAhamBannersPage from './admin/pages/AboutAhamBannersPage';
import AboutAhamOverviewPage from './admin/pages/AboutAhamOverviewPage';
import AboutAhamVisionMissionPage from './admin/pages/AboutAhamVisionMissionPage';
import AboutUsCoreValuesPage from './admin/pages/AboutUsCoreValuesPage';
import AboutUsJourneyPage from './admin/pages/AboutUsJourneyPage';
import OurTeamBannerPage from './admin/pages/OurTeamBannerPage';
import PartnershipBannerPage from './admin/pages/PartnershipBannerPage';
import AdminLeadershipPage from './admin/pages/AdminLeadershipPage';
import AdminFAQBannerPage from './admin/pages/AdminFAQBannerPage';
import AdminFAQManagementPage from './admin/pages/AdminFAQManagementPage';
import AdminRateMatrixPage from './admin/pages/AdminRateMatrixPage';
import AdminFAQDeviationsPage from './admin/pages/AdminFAQDeviationsPage';
import AdminScorecardBannerPage from './admin/pages/AdminScorecardBannerPage';
import AdminScorecardScorecardPage from './admin/pages/AdminScorecardScorecardPage';

import CareerBannersPage from './admin/pages/CareerBannersPage';
import BranchLocatorBannersPage from './admin/pages/BranchLocatorBannersPage';
import AdminBranchManagementPage from './admin/pages/AdminBranchManagementPage';
import AdminBranchNoticePage from './admin/pages/AdminBranchNoticePage';

import AdminBlogBannerPage from './admin/pages/AdminBlogBannerPage';
import AdminBlogManagementPage from './admin/pages/AdminBlogManagementPage';
import AdminBlogCTASettingsPage from './admin/pages/AdminBlogCTASettingsPage';
import ActivityLogPage from './admin/pages/ActivityLogPage'; // System Report
import AdminUserPage from './admin/pages/AdminUserPage';
import RolePermissionsPage from './admin/pages/RolePermissionsPage';
import ResourcesBannersPage from './admin/pages/ResourcesBannersPage';
import ResourcesManagementPage from './admin/pages/ResourcesManagementPage';
import ResourcesPage from './components/Resources/ResourcesPage';
import ContactInquiriesPage from './admin/pages/ContactInquiriesPage';
import CreditScoreInquiriesPage from './admin/pages/CreditScoreInquiriesPage';
import EligibilityInquiriesPage from './admin/pages/EligibilityInquiriesPage';
import DSAPartnerInquiriesPage from './admin/pages/DSAPartnerInquiriesPage';
import GrievanceInquiriesPage from './admin/pages/GrievanceInquiriesPage';
import AuctionEnquiriesPage from './admin/pages/AuctionEnquiriesPage';
import LifeAtAhamInquiriesPage from './admin/pages/LifeAtAhamInquiriesPage';
import DSAPartnershipEnquiriesPage from './admin/pages/DSAPartnershipEnquiriesPage';
import FestivalCampaignBannersPage from './admin/pages/FestivalCampaignBannersPage';
import FestivalCampaignContactPage from './admin/pages/FestivalCampaignContactPage';

// Modals
import EnquiryModal from './components/Modals/EnquiryModal';
import CreditScoreModal from './components/Modals/CreditScoreModal';

// Utils
import { scrollToSection } from './utils/helpers';
import MaintenancePage from './components/Maintenance/MaintenancePage';

const PlaceholderPage = ({ title }) => (
  <div className="bg-white rounded-3xl p-8 shadow-sm min-h-[400px] flex flex-col items-center justify-center text-center space-y-4">
    <h3 className="text-2xl font-bold text-slate-800">{title}</h3>
    <p className="text-slate-400 font-medium">This module is currently being integrated for dynamic management.</p>
  </div>
);

const NotFoundPage = () => {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6 py-16 bg-slate-50">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-3xl shadow-xl border border-slate-100 animate-in fade-in zoom-in duration-200">
        <div className="space-y-4">
          <div className="w-20 h-20 bg-[#283079]/5 rounded-full flex items-center justify-center mx-auto text-[#283079]">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 animate-pulse">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
            </svg>
          </div>
          <h1 className="text-4xl font-extrabold text-slate-800 tracking-tight">Page Not Found</h1>
          <p className="text-slate-500 text-sm leading-relaxed">
            We couldn't find the page you're looking for. It might have been moved, deleted, or never existed.
          </p>
        </div>
        <div className="pt-2">
          <a
            href="/"
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-semibold rounded-2xl text-white bg-[#283079] hover:bg-[#202660] transition-all duration-200 shadow-md hover:shadow-lg w-full"
          >
            Go back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

const DynamicBranchRoute = ({ currentLanguage, handleLanguageChange, setShowCreditScoreModal }) => {
  const location = useLocation();
  const isBranchPath = location.pathname.startsWith('/home-loan-in-') || location.pathname.startsWith('/affordable-home-loan-in-');

  // 301 Client Redirect for legacy /affordable-home-loan-in-* to /home-loan-in-*
  if (location.pathname.startsWith('/affordable-home-loan-in-')) {
    const newPath = location.pathname.replace('/affordable-home-loan-in-', '/home-loan-in-');
    return <Navigate to={newPath} replace />;
  }

  if (!isBranchPath) {
    return (
      <>
        <Header
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageChange}
          onCreditScoreClick={() => setShowCreditScoreModal(true)}
        />
        <NotFoundPage />
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header
        currentLanguage={currentLanguage}
        onLanguageChange={handleLanguageChange}
        onCreditScoreClick={() => setShowCreditScoreModal(true)}
      />
      <BranchPageTemplate />
      <Footer />
    </>
  );
};
const GlobalFloatingActions = ({ onEnquiryClick, onEMIClick, onScorecardClick }) => {
  const location = useLocation();
  if (location.pathname.startsWith('/admin')) {
    return null;
  }
  return (
    <FloatingActions
      onEnquiryClick={onEnquiryClick}
      onEMIClick={onEMIClick}
      onScorecardClick={onScorecardClick}
    />
  );
};

// TOGGLE MAINTENANCE MODE HERE
// Set to 'true' to show the "Under Construction" page.
// Set to 'false' to show the normal website.
const IS_MAINTENANCE_MODE = false;


function App() {
  const { i18n } = useTranslation();

  // Enforce canonical non-www & https in production (e.g. www.ahamhfc.com or http:// -> https://ahamhfc.com)
  useEffect(() => {
    if (typeof window !== 'undefined' && window.location) {
      const { hostname, protocol, pathname, search, hash } = window.location;
      if (hostname === 'www.ahamhfc.com' || (protocol === 'http:' && hostname === 'ahamhfc.com')) {
        window.location.replace(`https://ahamhfc.com${pathname}${search}${hash}`);
      }
    }
  }, []);

  // State
  const [showEnquiryModal, setShowEnquiryModal] = useState(false);
  const [showCreditScoreModal, setShowCreditScoreModal] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const [selectedJob, setSelectedJob] = useState(null); // For career page
  const [isAppLoading, setIsAppLoading] = useState(true);

  // Initial App Loading Effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAppLoading(false);
    }, 2000); // Show preloader for at least 2 seconds
    return () => clearTimeout(timer);
  }, []);


  // Language handling
  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    setCurrentLanguage(lang);
    document.documentElement.lang = lang;
    if (lang === 'ta') {
      document.body.classList.add('font-tamil');
    } else {
      document.body.classList.remove('font-tamil');
    }
  };

  useEffect(() => {
    handleLanguageChange(i18n.language);
  }, [i18n.language]);

  // Scroll to top on route change
  useEffect(() => {
    const handleRouteChange = () => window.scrollTo(0, 0);
    handleRouteChange();
    window.addEventListener('popstate', handleRouteChange);
    return () => window.removeEventListener('popstate', handleRouteChange);
  }, []);


  // Maintenance Mode Check - Moved after all hooks
  if (IS_MAINTENANCE_MODE) {
    return <MaintenancePage />;
  }

  return (
    <>
      <Preloader isLoading={isAppLoading} />
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <div className="min-h-screen bg-white">
            <Toaster
              position="top-right"
              containerStyle={{ zIndex: 999999 }}
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#283079',
                  color: '#ffffff',
                  fontSize: '14px',
                  borderRadius: '8px',
                  padding: '12px 16px',
                },
                success: { iconTheme: { primary: '#10B981', secondary: '#ffffff' } },
                error: { iconTheme: { primary: '#EF4444', secondary: '#ffffff' } },
              }}
            />

            {/* Global Enquiry Modal - Available on all pages */}
            {showEnquiryModal && (
              <EnquiryModal isOpen={showEnquiryModal} onClose={() => setShowEnquiryModal(false)} />
            )}

            {showCreditScoreModal && (
              <CreditScoreModal isOpen={showCreditScoreModal} onClose={() => setShowCreditScoreModal(false)} />
            )}

            <Routes>
              {/* Admin Routes */}
              <Route path="/admin" element={<LoginPage />} />
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="dashboard/emi-calculator" element={<EMICalculatorPage />} />
                <Route path="banners" element={<BannersPage />} />
                <Route path="why-choose" element={<WhyChoosePage />} />
                <Route path="products" element={<ProductsPage />} />
                <Route path="testimonials" element={<TestimonialsPage />} />
                <Route path="scorecard" element={<ScorecardPage />} />
                <Route path="important-news" element={<ImportantNewsPage />} />
                <Route path="festival-campaign/banner" element={<FestivalCampaignBannersPage />} />
                <Route path="festival-campaign/contact" element={<FestivalCampaignContactPage />} />
                <Route path="home-construction-loan/banner" element={<HomeConstructionLoanBannersPage />} />
                <Route path="home-construction-loan/overview" element={<HomeConstructionLoanOverviewPage />} />
                <Route path="home-construction-loan/key-benefits" element={<HomeConstructionLoanKeyBenefitsPage />} />
                <Route path="home-construction-loan/eligibility" element={<HomeConstructionLoanEligibilityPage />} />
                <Route path="home-construction-loan/documents" element={<HomeConstructionLoanDocumentsPage />} />
                <Route path="home-construction-loan/interest-rates" element={<HomeConstructionLoanInterestRatesPage />} />
                <Route path="home-construction-loan/faqs" element={<HomeConstructionLoanFAQPage />} />
                <Route path="home-construction-loan/cta-banner" element={<HomeConstructionLoanCTABannerPage />} />
                <Route path="home-purchase-loan/banner" element={<HomePurchaseLoanBannersPage />} />
                <Route path="home-purchase-loan/overview" element={<HomePurchaseLoanOverviewPage />} />
                <Route path="home-purchase-loan/key-benefits" element={<HomePurchaseLoanKeyBenefitsPage />} />
                <Route path="home-purchase-loan/eligibility" element={<HomePurchaseLoanEligibilityPage />} />
                <Route path="home-purchase-loan/documents" element={<HomePurchaseLoanDocumentsPage />} />
                <Route path="home-purchase-loan/interest-rates" element={<HomePurchaseLoanInterestRatesPage />} />
                <Route path="home-purchase-loan/faqs" element={<HomePurchaseLoanFAQPage />} />
                <Route path="home-purchase-loan/cta-banner" element={<HomePurchaseLoanCTABannerPage />} />
                <Route path="home-composite-loan/banner" element={<HomeCompositeLoanBannersPage />} />
                <Route path="home-composite-loan/overview" element={<HomeCompositeLoanOverviewPage />} />
                <Route path="home-composite-loan/key-benefits" element={<HomeCompositeLoanKeyBenefitsPage />} />
                <Route path="home-composite-loan/eligibility" element={<HomeCompositeLoanEligibilityPage />} />
                <Route path="home-composite-loan/documents" element={<HomeCompositeLoanDocumentsPage />} />
                <Route path="home-composite-loan/interest-rates" element={<HomeCompositeLoanInterestRatesPage />} />
                <Route path="home-composite-loan/faqs" element={<HomeCompositeLoanFAQPage />} />
                <Route path="home-composite-loan/cta-banner" element={<HomeCompositeLoanCTABannerPage />} />

                {/* Home Renovation Loan Section */}
                <Route path="home-renovation-loan/overview" element={<HomeRenovationLoanOverviewPage />} />
                <Route path="home-renovation-loan/key-benefits" element={<HomeRenovationLoanKeyBenefitsPage />} />
                <Route path="home-renovation-loan/eligibility" element={<HomeRenovationLoanEligibilityPage />} />
                <Route path="home-renovation-loan/documents" element={<HomeRenovationLoanDocumentsPage />} />
                <Route path="home-renovation-loan/interest-rates" element={<HomeRenovationLoanInterestRatesPage />} />
                <Route path="home-renovation-loan/faqs" element={<HomeRenovationLoanFAQPage />} />
                <Route path="home-renovation-loan/banners" element={<HomeRenovationLoanBannersPage />} />
                <Route path="home-renovation-loan/cta-banner" element={<HomeRenovationLoanCTABannerPage />} />

                {/* Home Extension Loan Section */}
                <Route path="home-extension-loan/banner" element={<HomeExtensionLoanBannersPage />} />
                <Route path="home-extension-loan/overview" element={<HomeExtensionLoanOverviewPage />} />
                <Route path="home-extension-loan/key-benefits" element={<HomeExtensionLoanKeyBenefitsPage />} />
                <Route path="home-extension-loan/eligibility" element={<HomeExtensionLoanEligibilityPage />} />
                <Route path="home-extension-loan/documents" element={<HomeExtensionLoanDocumentsPage />} />
                <Route path="home-extension-loan/interest-rates" element={<HomeExtensionLoanInterestRatesPage />} />
                <Route path="home-extension-loan/faqs" element={<HomeExtensionLoanFAQPage />} />
                <Route path="home-extension-loan/cta-banner" element={<HomeExtensionLoanCTABannerPage />} />

                {/* Balance Transfer Loan Section */}
                <Route path="balance-transfer-loan/banner" element={<BalanceTransferLoanBannersPage />} />
                <Route path="balance-transfer-loan/overview" element={<BalanceTransferLoanOverviewPage />} />
                <Route path="balance-transfer-loan/key-benefits" element={<BalanceTransferLoanKeyBenefitsPage />} />
                <Route path="balance-transfer-loan/eligibility" element={<BalanceTransferLoanEligibilityPage />} />
                <Route path="balance-transfer-loan/documents" element={<BalanceTransferLoanDocumentsPage />} />
                <Route path="balance-transfer-loan/interest-rates" element={<BalanceTransferLoanInterestRatesPage />} />
                <Route path="balance-transfer-loan/faqs" element={<BalanceTransferLoanFAQPage />} />
                <Route path="balance-transfer-loan/cta-banner" element={<BalanceTransferLoanCTABannerPage />} />

                {/* NRI Loan Section */}
                <Route path="nri-loan/banner" element={<NRILoanBannersPage />} />
                <Route path="nri-loan/overview" element={<NRILoanOverviewPage />} />
                <Route path="nri-loan/key-benefits" element={<NRILoanKeyBenefitsPage />} />
                <Route path="nri-loan/eligibility" element={<NRILoanEligibilityPage />} />
                <Route path="nri-loan/documents" element={<NRILoanDocumentsPage />} />
                <Route path="nri-loan/interest-rates" element={<NRILoanInterestRatesPage />} />
                <Route path="nri-loan/faqs" element={<NRILoanFAQPage />} />
                <Route path="nri-loan/cta-banner" element={<NRILoanCTABannerPage />} />

                {/* Top-up Loan Section */}
                <Route path="top-up-loan/banner" element={<TopUpLoanBannersPage />} />
                <Route path="top-up-loan/overview" element={<TopUpLoanOverviewPage />} />
                <Route path="top-up-loan/key-benefits" element={<TopUpLoanKeyBenefitsPage />} />
                <Route path="top-up-loan/eligibility" element={<TopUpLoanEligibilityPage />} />
                <Route path="top-up-loan/documents" element={<TopUpLoanDocumentsPage />} />
                <Route path="top-up-loan/interest-rates" element={<TopUpLoanInterestRatesPage />} />
                <Route path="top-up-loan/faqs" element={<TopUpLoanFAQPage />} />
                <Route path="top-up-loan/cta-banner" element={<TopUpLoanCTABannerPage />} />

                {/* Mortgage Loan Section */}
                <Route path="mortgage-loan/banner" element={<MortgageLoanBannersPage />} />
                <Route path="mortgage-loan/overview" element={<MortgageLoanOverviewPage />} />
                <Route path="mortgage-loan/key-benefits" element={<MortgageLoanKeyBenefitsPage />} />
                <Route path="mortgage-loan/eligibility" element={<MortgageLoanEligibilityPage />} />
                <Route path="mortgage-loan/documents" element={<MortgageLoanDocumentsPage />} />
                <Route path="mortgage-loan/interest-rates" element={<MortgageLoanInterestRatesPage />} />
                <Route path="mortgage-loan/faqs" element={<MortgageLoanFAQPage />} />
                <Route path="mortgage-loan/cta-banner" element={<MortgageLoanCTABannerPage />} />

                {/* Partner Us Section */}
                <Route path="partner-us/banner" element={<DSAPartnerProgramBannersPage />} />
                <Route path="partner-us/overview" element={<DSAPartnerProgramOverviewPage />} />
                <Route path="partner-us/benefits" element={<DSAPartnerProgramBenefitsPage />} />
                <Route path="partner-us/who-can-join" element={<DSAPartnerProgramWhoCanJoinPage />} />
                <Route path="partner-us/how-it-works" element={<DSAPartnerProgramHowItWorksPage />} />
                <Route path="partner-us/support-training" element={<DSAPartnerProgramSupportTrainingPage />} />
                <Route path="partner-us/success-stories" element={<DSAPartnerProgramSuccessStoriesPage />} />
                <Route path="partner-us/registration-requirements" element={<DSAPartnerProgramRegistrationRequirementsPage />} />
                <Route path="partner-us/faqs" element={<DSAPartnerProgramFAQPage />} />
                <Route path="partner-us/high-demand-products" element={<HighDemandProductsPage />} />
                <Route path="partner-us/cta-banner" element={<DSAPartnerProgramCTABannerPage />} />

                {/* Investor Info Section */}
                <Route path="investor-info/banner" element={<InvestorInfoBannersPage />} />
                <Route path="investor-info/foundation-settings" element={<InvestorFoundationSettingsPage />} />
                <Route path="investor-info/vision-points" element={<InvestorFoundationPointsPage />} />
                <Route path="investor-info/progress-settings" element={<InvestorProgressSettingsPage />} />
                <Route path="investor-info/progress-highlights" element={<InvestorProgressHighlightsPage />} />
                <Route path="investor-info/trust-settings" element={<InvestorTrustSettingsPage />} />
                <Route path="investor-info/governance-highlights" element={<InvestorGovernanceHighlightsPage />} />
                <Route path="investor-info/cta-banner" element={<InvestorInfoCTABannerPage />} />

                {/* PMAY Section */}
                <Route path="pmay/banner" element={<PMAYBannersPage />} />
                <Route path="pmay/overview" element={<PMAYOverviewPage />} />
                <Route path="pmay/eligibility" element={<PMAYEligibilityPage />} />

                {/* Governance Routes */}
                <Route path="governance/banner" element={<GovernanceBannersPage />} />
                <Route path="governance/foundation" element={<GovernanceFoundationPage />} />
                <Route path="governance/transparency" element={<GovernanceTransparencyPage />} />
                <Route path="governance/oversight" element={<GovernanceOversightPage />} />
                <Route path="governance/ethics" element={<GovernanceEthicsPage />} />
                <Route path="governance/cta-banner" element={<GovernanceCTABannerPage />} />

                {/* DSA Onboarding Routes */}
                <Route path="dsa-onboarding/banner" element={<DSAOnboardingBannersPage />} />
                <Route path="dsa-onboarding/benefits" element={<DSAOnboardingBenefitsPage />} />
                <Route path="dsa-onboarding/steps" element={<DSAOnboardingStepsPage />} />
                <Route path="dsa-onboarding/requirements" element={<DSAOnboardingRequirementsPage />} />
                <Route path="dsa-onboarding/cta" element={<DSAOnboardingCTABannerPage />} />

                {/* Risk Classification Routes */}
                <Route path="risk-classification/banner" element={<RiskClassificationBannersPage />} />
                <Route path="risk-classification/cards" element={<RiskClassificationCardsPage />} />
                <Route path="risk-classification/table-data" element={<RiskClassificationTablePage />} />

                {/* E-Auction Routes */}
                <Route path="e-auction/banner" element={<EAuctionBannersPage />} />
                <Route path="e-auction/process" element={<EAuctionProcessPage />} />
                <Route path="e-auction/properties" element={<EAuctionPropertiesPage />} />
                <Route path="e-auction/getting-started" element={<EAuctionGettingStartedPage />} />
                <Route path="e-auction/legal-information" element={<EAuctionLegalInformationPage />} />

                {/* Rating Certificate Routes */}
                <Route path="rating-certificate/banner" element={<RatingCertificateBannersPage />} />
                <Route path="rating-certificate/value" element={<RatingCertificateValuePage />} />
                <Route path="rating-certificate/credentials" element={<RatingCertificateCredentialsPage />} />
                <Route path="rating-certificate/behind-scenes" element={<RatingBehindScenesPage />} />
                <Route path="rating-certificate/advantage" element={<RatingCertificateAdvantagePage />} />
                <Route path="rating-certificate/pledge" element={<RatingCertificatePledgePage />} />
                <Route path="rating-certificate/assessments" element={<RatingCertificateAssessmentsPage />} />
                <Route path="rating-certificate/cta" element={<RatingCertificateCTAPage />} />

                {/* Grievance Redressal Routes */}
                <Route path="grievance-redressal/banner" element={<GrievancesRedressalBannersPage />} />
                <Route path="grievance-redressal/steps" element={<GrievancesRedressalStepsPage />} />
                <Route path="grievance-redressal/methods" element={<GrievanceComplaintMethodsPage />} />
                <Route path="grievance-redressal/level2" element={<GrievanceLevel2Page />} />
                <Route path="grievance-redressal/level3" element={<GrievanceLevel3Page />} />
                <Route path="grievance-redressal/commitment" element={<GrievanceCommitmentPage />} />

                {/* Secured Assets Routes */}
                <Route path="secured-assets/banner" element={<SecuredAssetsBannersPage />} />
                <Route path="secured-assets/core-concept" element={<SecuredAssetsCoreConceptPage />} />
                <Route path="secured-assets/finance" element={<SecuredAssetsFinancePage />} />
                <Route path="secured-assets/terms" element={<SecuredAssetsTermsPage />} />
                <Route path="secured-assets/transparency" element={<SecuredAssetsDefaultPage />} />
                <Route path="secured-assets/release" element={<SecuredAssetsReleasePage />} />
                <Route path="secured-assets/table-data" element={<SecuredAssetsTablePage />} />
                <Route path="secured-assets/cta-banner" element={<SecuredAssetsCTABannerPage />} />
                <Route path="life-at-aham/banner" element={<LifeAtAhamBannersPage />} />
                <Route path="life-at-aham/culture" element={<LifeAtAhamCulturePage />} />
                <Route path="life-at-aham/thrive" element={<LifeAtAhamThrivePage />} />
                <Route path="life-at-aham/journey" element={<LifeAtAhamJourneyPage />} />
                <Route path="life-at-aham/beyond" element={<LifeAtAhamBeyondPage />} />
                <Route path="life-at-aham/recognition" element={<LifeAtAhamRecognitionPage />} />
                <Route path="life-at-aham/cta-banner" element={<LifeAtAhamCTABannerPage />} />

                {/* Gallery Routes */}
                <Route path="gallery/banners" element={<GalleryBannersPage />} />
                <Route path="gallery/work-images" element={<GalleryWorkImagesPage />} />
                <Route path="gallery/celebration-images" element={<GalleryCelebrationImagesPage />} />
                <Route path="gallery/growth-images" element={<GalleryGrowthImagesPage />} />
                <Route path="gallery/cta" element={<GalleryCTAManagementPage />} />
                <Route path="about-aham/banner" element={<AboutAhamBannersPage />} />
                <Route path="about-aham/overview" element={<AboutAhamOverviewPage />} />
                <Route path="about-aham/vision-mission" element={<AboutAhamVisionMissionPage />} />
                <Route path="about-aham/core-values" element={<AboutUsCoreValuesPage />} />
                <Route path="about-aham/journey" element={<AboutUsJourneyPage />} />

                {/* Our Team Routes */}
                <Route path="our-team/banner" element={<OurTeamBannerPage />} />
                <Route path="leadership/active" element={<AdminLeadershipPage />} />

                {/* FAQ Routes */}
                <Route path="faq/banner" element={<AdminFAQBannerPage />} />
                <Route path="faq/management" element={<AdminFAQManagementPage />} />
                <Route path="faq/rate-matrix" element={<AdminRateMatrixPage />} />
                <Route path="faq/deviations" element={<AdminFAQDeviationsPage />} />

                {/* Admin Scorecard Routes */}
                <Route path="scorecard/banner" element={<AdminScorecardBannerPage />} />
                <Route path="scorecard/scorecard-section" element={<AdminScorecardScorecardPage />} />
                <Route path="scorecard/eligibility-cards" element={<AdminScorecardEligibilityCardsPage />} />
                <Route path="scorecard/max-loan" element={<AdminScorecardMaxLoanPage />} />
                <Route path="scorecard/eligibility-factors" element={<AdminScorecardEligibilityFactorsPage />} />
                <Route path="scorecard/eligibility-tips" element={<AdminScorecardEligibilityTipsPage />} />
                <Route path="scorecard/beyond-numbers" element={<AdminScorecardBeyondNumbersPage />} />
                <Route path="scorecard/why-choose-section" element={<AdminScorecardWhyChoosePage />} />
                <Route path="scorecard/faq-management" element={<AdminScorecardFaqsPage />} />
                <Route path="scorecard/products-section" element={<AdminScorecardProductsPage />} />

                {/* Partnership Routes */}
                <Route path="partnership/banner" element={<PartnershipBannerPage />} />

                {/* Career Routes */}
                <Route path="career/banner" element={
                  <ProtectedRoute permission="career">
                    <CareerBannersPage />
                  </ProtectedRoute>
                } />

                {/* Branch Locator Routes */}
                <Route path="branch-locator/banner" element={<BranchLocatorBannersPage />} />
                <Route path="branch-locator/management" element={<AdminBranchManagementPage />} />
                <Route path="branch-locator/notice" element={<AdminBranchNoticePage />} />

                {/* Blog Routes */}
                <Route path="blog/banner" element={<AdminBlogBannerPage />} />
                <Route path="blog/management" element={<AdminBlogManagementPage />} />
                <Route path="blog/cta-settings" element={<AdminBlogCTASettingsPage />} />

                {/* Resources Routes */}
                <Route path="resources/banner" element={<ResourcesBannersPage />} />
                <Route path="resources/management" element={<ResourcesManagementPage />} />

                {/* Enquiries Routes */}
                <Route path="enquiries/contact" element={
                  <ProtectedRoute permission="enquiries_contact">
                    <ContactInquiriesPage />
                  </ProtectedRoute>
                } />
                <Route path="enquiries/credit-score" element={
                  <ProtectedRoute permission="enquiries_credit_score">
                    <CreditScoreInquiriesPage />
                  </ProtectedRoute>
                } />
                <Route path="enquiries/eligibility" element={
                  <ProtectedRoute permission="enquiries_eligibility">
                    <EligibilityInquiriesPage />
                  </ProtectedRoute>
                } />
                <Route path="enquiries/dsa-partner" element={
                  <ProtectedRoute permission="enquiries_dsa">
                    <DSAPartnerInquiriesPage />
                  </ProtectedRoute>
                } />
                <Route path="enquiries/auction" element={
                  <ProtectedRoute permission="enquiries_auction">
                    <AuctionEnquiriesPage />
                  </ProtectedRoute>
                } />
                <Route path="enquiries/grievance" element={
                  <ProtectedRoute permission="enquiries_grievance">
                    <GrievanceInquiriesPage />
                  </ProtectedRoute>
                } />

                <Route path="enquiries/life-at-aham" element={
                  <ProtectedRoute permission="enquiries_life_at_aham">
                    <LifeAtAhamInquiriesPage />
                  </ProtectedRoute>
                } />

                <Route path="enquiries/dsa-partnership" element={
                  <ProtectedRoute permission="enquiries_dsa_partnership">
                    <DSAPartnershipEnquiriesPage />
                  </ProtectedRoute>
                } />

                {/* Settings Routes */}
                <Route path="settings/report" element={
                  <ProtectedRoute permission="settings_report">
                    <ActivityLogPage />
                  </ProtectedRoute>
                } />
                <Route path="settings/users" element={
                  <ProtectedRoute permission="settings_users">
                    <AdminUserPage />
                  </ProtectedRoute>
                } />
                <Route path="settings/permissions" element={
                  <ProtectedRoute permission="settings_permissions">
                    <RolePermissionsPage />
                  </ProtectedRoute>
                } />

                {/* Testimonials Routes */}

                {/* GMB Branch Pages Admin Routes */}
                <Route path="gmb-branch-pages" element={
                  <ProtectedRoute permission="branch_locator">
                    <AdminGMBBranchManagement />
                  </ProtectedRoute>
                } />
                <Route path="gmb-branch-pages/:branchId/sections/:sectionKey" element={
                  <ProtectedRoute permission="branch_locator">
                    <AdminGMBSectionEditor />
                  </ProtectedRoute>
                } />

              </Route>

              {/* Thank You Page */}
              <Route
                path="/thank-you"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <ThankYou />
                    <Footer />
                    
                  </>
                }
              />

              {/* Resources Page */}
              <Route
                path="/resources"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <ResourcesPage />
                    <Footer />
                    
                  </>
                }
              />

              {/* Home Page */}
              <Route
                path="/"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />

                    <main className="overflow-hidden">
                      <HeroSection onEnquiryClick={() => setShowEnquiryModal(true)} />
                      <WhyChooseSection />
                      <ProductsSection />
                      <EMICalculatorSection />
                      <EligibilityScorecardSection />
                      <TestimonialsSection />
                      <BlogSection />
                      <ImportantNewsSection />
                    </main>
                    <Footer />
                    

                  </>
                }
              />

              {/* Scorecard Page */}
              <Route
                path="/home-loan-eligibility-calculator"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <ScorecardFrontendPage />
                    <Footer />
                    
                  </>
                }
              />
              <Route
                path="/scorecard"

                element={<Navigate to="/home-loan-eligibility-calculator" replace />}
              />

              {/* EMI Calculator Full Page */}
              <Route
                path="/home-loan-emi-calculator"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <EMICalculatorFrontendPage />
                    <Footer />
                    
                  </>
                }
              />
              <Route
                path="/emi-calculator"

                element={<Navigate to="/home-loan-emi-calculator" replace />}
              />

              {/* Home Construction Loan Page */}
              <Route
                path="/home-construction-loan-india"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <HomeConstructionLoanPage />
                    <Footer />
                    
                  </>
                }
              />

              {/* Other Pages */}
              <Route
                path="/pmay-2-0-scheme-apply-online"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <PMAY2Page />
                    <Footer />
                    
                  </>
                }
              />
              <Route
                path="/become-home-loan-dsa"
                // element={
                //   <>
                //     <Header
                //       currentLanguage={currentLanguage}
                //       onLanguageChange={handleLanguageChange}
                //       onCreditScoreClick={() => setShowCreditScoreModal(true)}
                //     />
                //     <PartnerWithUs />
                //     <Footer />
                //     
                //   </>
                // }
                element={<Navigate to="/become-home-loan-dsa-partner" replace />}
              />
              <Route
                path="/governance"
                // element={
                //   <>
                //     <Header
                //       currentLanguage={currentLanguage}
                //       onLanguageChange={handleLanguageChange}
                //       onCreditScoreClick={() => setShowCreditScoreModal(true)}
                //     />
                //     <Governance />
                //     <Footer />
                //     
                //   </>
                // }
                element={<Navigate to="/corporate-governance-policies" replace />}
              />
              <Route
                path="/risk-classification-framework-policy"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <RiskClassification />
                    <Footer />
                    
                  </>
                }
              />

              {/* Career List Page */}
              <Route
                path="/career"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <Career setSelectedJob={setSelectedJob} />
                    <Footer />
                    
                  </>
                }
              />

              {/* 301 Redirect for duplicate job id 1 */}
              <Route
                path="/career/1"
                element={<Navigate to="/career" replace />}
              />

              {/* Job Details Page */}
              <Route
                path="/career/:id"
                element={<JobDetails setSelectedJob={setSelectedJob} />}
              />

              {/* About Us Page */}
              <Route
                path="/about-aham-housing-finance"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <AboutUs />
                    <Footer />
                    
                  </>
                }
              />

              <Route path="/contact-aham-housing-finance" element={
                <>
                  <Header
                    currentLanguage={currentLanguage}
                    onLanguageChange={handleLanguageChange}
                    onCreditScoreClick={() => setShowCreditScoreModal(true)}
                  />
                  <ContactUs />
                  <Footer />
                  
                </>
              } />

              <Route path="/festival-campaign" element={
                <>
                  <Header
                    currentLanguage={currentLanguage}
                    onLanguageChange={handleLanguageChange}
                    onCreditScoreClick={() => setShowCreditScoreModal(true)}
                  />
                  <FestivalCampaign />
                  <Footer />
                  
                </>
              } />

              <Route
                path="/customer-360-eligibility-calculator"
                // element={
                //   <>
                //     <Header
                //       currentLanguage={currentLanguage}
                //       onLanguageChange={handleLanguageChange}
                //       onCreditScoreClick={() => setShowCreditScoreModal(true)}
                //     />
                //     <Customer360EligibilityCalculator />
                //     <Footer />
                //     
                //   </>
                // }
                element={<Navigate to="/home-loan-emi-calculator" replace />}
              />

              <Route
                path="/management-team"
                // element={
                //   <>
                //     <Header
                //       currentLanguage={currentLanguage}
                //       onLanguageChange={handleLanguageChange}
                //       onCreditScoreClick={() => setShowCreditScoreModal(true)}
                //     />
                //     <ManagementTeamSection />

                //     <Footer />
                //     
                //   </>
                // }
                element={<Navigate to="/aham-housing-finance-partnership-channel-partner" replace />}
              />

              <Route
                path="/home-loan-faq"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <main className="overflow-hidden">
                      <Faq />
                    </main>
                    <Footer />
                    
                  </>
                }
              />

              <Route
                path="/directors"
                // element={
                //   <>
                //     <Header
                //       currentLanguage={currentLanguage}
                //       onLanguageChange={handleLanguageChange}
                //       onCreditScoreClick={() => setShowCreditScoreModal(true)}
                //     />
                //     <Directors />
                //     <Footer />
                //     
                //   </>
                // }
                element={<Navigate to="/aham-housing-finance-partnership-channel-partner" replace />}
              />
              <Route path="/home-loan-blog-aham-housing-finance" element={
                <>
                  <Header
                    currentLanguage={currentLanguage}
                    onLanguageChange={handleLanguageChange}
                    onCreditScoreClick={() => setShowCreditScoreModal(true)}
                  />
                  <Blog />
                  <Footer />
                  
                </>
              }
              />

              <Route
                path="/life-at-aham-housing-finance-careers"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <LifeAham />
                    <Footer />
                    
                  </>
                }
              />

              <Route
                path="/aham-moments-home-loan-success-stories"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <AhamMoments />
                    <Footer />
                    
                  </>
                }
              />

              <Route
                path="/investor-information"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <InvestorInfo />
                    <Footer />
                    
                  </>
                }
              />

              <Route
                path="/grievance-redressal-policy-customer-support"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <Grievances />
                    <Footer />
                    
                  </>
                }
              />

              <Route
                path="/home-loan-dsa-registration-online"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <DSAOnboarding onEnquiryClick={() => setShowEnquiryModal(true)} />
                    <Footer />
                    
                  </>
                }
              />

              <Route
                path="/aham-housing-finance-e-auction-sale-notice"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <EAuction />
                    <Footer />
                    
                  </>
                }
              />

              <Route
                path="/aham-housing-finance-credit-rating-certificate"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <RatingCertificate />
                    <Footer />
                    
                  </>
                }
              />


              <Route
                path="/secured-assets-sarfaesi-aham-housing-finance"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <SecuredAssets />
                    <Footer />
                    
                  </>
                }
              />

              <Route
                path="/corporate-governance-policies"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <CorporateGovernance />
                    <Footer />
                    
                  </>
                }
              />

              <Route
                path="/aham-housing-finance-partnership-channel-partner"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <Leadership />
                    <Footer />
                    
                  </>
                }
              />

              <Route
                path="/become-home-loan-dsa-partner"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <DSAPartnerProgram />
                    <Footer />
                    
                  </>
                }
              />

              {/* Home Composite Loan Page */}
              <Route
                path="/composite-home-loan-plot-construction"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <HomeCompositeLoanPage />
                    <Footer />
                    
                  </>
                }
              />

              {/* Home NRI Loan Page */}
              <Route
                path="/nri-home-loan-india"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <NRILoanPage />
                    <Footer />
                    
                  </>
                }
              />

              {/* Home Home purchase Loan Page */}
              <Route
                path="/home-purchase-loan"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <HomePurchaseLoanPage />
                    <Footer />
                    
                  </>
                }
              />

              {/* Home Home Renovation Loan Page */}
              <Route
                path="/home-renovation-loan"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <HomeRenovationLoanPage />
                    <Footer />
                    
                  </>
                }
              />


              {/* Home  Extension Loan Page */}
              <Route
                path="/home-extension-loan"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <HomeExtensionLoanPage />
                    <Footer />
                    
                  </>
                }
              />

              {/* Home  balance Transfer Loan Page */}
              <Route
                path="/home-loan-balance-transfer"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <BalanceTransferLoan />
                    <Footer />
                    
                  </>
                }
              />
              {/* Home  balance Transfer Loan Page */}
              <Route
                path="/top-up-loan-for-home-loan"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <TopUpLoan />
                    <Footer />
                    
                  </>
                }
              />

              {/* Privacy Policy Page */}
              <Route
                path="/privacy-policy"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <PrivacyPolicy />
                    <Footer />
                    
                  </>
                }
              />


              {/* cookie Policy Page */}
              <Route
                path="/cookies"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <CookiePolicy />
                    <Footer />
                    
                  </>
                }
              />

              {/* Home mortage Loan Page */}
              <Route
                path="/loan-against-property-mortgage-loan"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <MortgageLoan />
                    <Footer />
                    
                  </>
                }
              />

              {/* Blog Inner Page */}
              <Route
                path="/home-loan-blog-aham-housing-finance/:id"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <BlogInner />
                    <Footer />
                    
                  </>
                }
              />

              {/* Branch Locator Page */}
              <Route path="/branch-locator-aham-housing-finance-home-loan" element={
                <>
                  <Header
                    currentLanguage={currentLanguage}
                    onLanguageChange={handleLanguageChange}
                    onCreditScoreClick={() => setShowCreditScoreModal(true)}
                  />
                  <BranchLocator />
                  <Footer />
                  
                </>
              } />

              {/* 301 Permanent Redirect for Madurai Branch */}
              <Route
                path="/branches/madurai"
                element={<Navigate to="/home-loan-in-madurai" replace />}
              />
              <Route
                path="/branches/madurai/*"
                element={<Navigate to="/home-loan-in-madurai" replace />}
              />
              <Route
                path="/branch/madurai"
                element={<Navigate to="/home-loan-in-madurai" replace />}
              />
              <Route
                path="/branch/madurai/*"
                element={<Navigate to="/home-loan-in-madurai" replace />}
              />

              {/* 301 Permanent Redirects for SEO & Canonical URLs */}
              <Route
                path="/career/1"
                element={<Navigate to="/career" replace />}
              />
              <Route
                path="/careers"
                element={<Navigate to="/career" replace />}
              />
              <Route
                path="/pmay.html"
                element={<Navigate to="/pmay-2-0-scheme-apply-online" replace />}
              />
              <Route
                path="/faq.aspx"
                element={<Navigate to="/home-loan-faq" replace />}
              />
              <Route
                path="/contact"
                element={<Navigate to="/contact-aham-housing-finance" replace />}
              />
              <Route
                path="/pmay.aspx"
                element={<Navigate to="/pmay-2-0-scheme-apply-online" replace />}
              />
              <Route
                path="/blog/what-is-home-extension-loan"
                element={<Navigate to="/home-loan-blog-aham-housing-finance/7" replace />}
              />
              <Route
                path="/blog/what-is-home-extension-loan/"
                element={<Navigate to="/home-loan-blog-aham-housing-finance/7" replace />}
              />
              <Route
                path="/home-loan-eligibility"
                element={<Navigate to="/home-loan-eligibility-calculator" replace />}
              />
              <Route
                path="/home-loan-documents-required"
                element={<Navigate to="/home-loan-blog-aham-housing-finance/18" replace />}
              />

              {/* Dynamic GMB Branch Pages (e.g. /affordable-home-loan-in-theni, /affordable-home-loan-in-madurai) */}
              <Route path="/:slug" element={
                <DynamicBranchRoute
                  currentLanguage={currentLanguage}
                  handleLanguageChange={handleLanguageChange}
                  setShowCreditScoreModal={setShowCreditScoreModal}
                />
              } />

              {/* 404 Not Found Page */}
              <Route
                path="*"
                element={
                  <>
                    <Header
                      currentLanguage={currentLanguage}
                      onLanguageChange={handleLanguageChange}
                      onCreditScoreClick={() => setShowCreditScoreModal(true)}
                    />
                    <NotFoundPage />
                    <Footer />
                    
                  </>
                }
              />


            
            </Routes>
            <GlobalFloatingActions 
              onEnquiryClick={() => setShowEnquiryModal(true)}
              onEMIClick={() => scrollToSection('emi-calculator')}
              onScorecardClick={() => scrollToSection('eligibility-scorecard')}
            />
          </div>
        </Router>
      </AuthProvider>
    </>
  );
}

export default App;